import * as React from 'react';
import classNames from 'classnames';
import './Tag.scss';

export interface ITagsProps {
  className?: string;
  children: React.ReactNode
}

const Tags = ({ className, children }: ITagsProps) => (
  <div className={classNames('tags', className)}>{children}</div>
);

export default Tags;



// WEBPACK FOOTER //
// ./src/components/Tag/Tags.tsx